/* CVF-040-AB-MD-PDP-CVR */
document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('cvf-040-ab-active')) return;

  const anchors = document.querySelectorAll('.cvf-040-ab__anchor');
  if (!anchors.length) return;

  const getScrollOffset = () => {
    const header =
      document.querySelector('.shopify-section-header-sticky') ||
      document.querySelector('sticky-header') ||
      document.querySelector('.header-wrapper');

    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    return headerHeight + 24;
  };

  const scrollToComparison = (target) => {
    const offset = getScrollOffset();
    const rect = target.getBoundingClientRect();
    const targetTop = rect.top + window.scrollY;
    const scrollTop = Math.max(0, targetTop - offset);
    const alreadyVisible = rect.top >= offset && rect.bottom <= window.innerHeight;

    if (alreadyVisible) return;

    window.scrollTo({ top: scrollTop, behavior: 'smooth' });
  };

  anchors.forEach((anchor) => {
    anchor.addEventListener('pointerdown', (event) => {
      event.stopPropagation();
    });

    anchor.addEventListener('click', (event) => {
      const href = anchor.getAttribute('href');
      if (!href || !href.startsWith('#')) return;

      const target = document.querySelector(href);
      if (!target) return;

      event.preventDefault();
      event.stopPropagation();
      scrollToComparison(target);
    });
  });
});
